import { SpaceResponseModel } from 'api';

export const isHasSpaceInAvailableSpaces = (
  availableSpaces: SpaceResponseModel[],
  id: string | null,
) => {
  if (!id) return false;
  return !!availableSpaces.find(({ id: availableId }) => id === availableId);
};
